import { Component, ContentChild, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatMenu } from '@angular/material/menu';
import { BaseViewComponent, ChipTimeChipPickerLabels } from '@sb/library/base';
import { SBTime } from '@sb/library/localization';
import { ChipButtonComponent } from '../chip-button.component';
import { ChipTimeRangePickerBottomSheetComponent } from './bottom-sheet/chip-time-range-picker-bottom-sheet.component';

@Component({
    selector: 'lib-chip-time-range-picker',
    templateUrl: './chip-time-range-picker.component.html',
    styleUrls: ['./chip-time-range-picker.component.scss']
})
export class ChipTimeRangePickerComponent extends BaseViewComponent {
    @Input() loading: boolean = false;
    @Input() labels: ChipTimeChipPickerLabels = new ChipTimeChipPickerLabels();

    private _menuTrigger!: MatMenu;

    private _startSBTime: SBTime | null = null;
    private _endSBTime: SBTime | null = null;

    private _updated: boolean = false;

    @ViewChild("chipButton") chipButton!: ChipButtonComponent;
    @ContentChild('title', { static: false }) title!: ElementRef;

    @Input()
    set endTime(value: string) {
        if (value) {
            this._endSBTime = SBTime.FromISO(value);
        } else {
            this._endSBTime = null;
        }
    }

    @Input()
    set startTime(value: string) {
        if (value) {
            this._startSBTime = SBTime.FromISO(value);
        } else {
            this._startSBTime = null;
        }
    }

    @Output() selectionChange: EventEmitter<(SBTime | null)[] | null> = new EventEmitter();

    constructor(private _MatBottomSheet: MatBottomSheet) {
        super();
    }

    TimeChanged(range: (SBTime | null)[]): void {
        if (range) {
            if (this._startSBTime?.ToISO() != range[0]?.ToISO() || this._endSBTime?.ToISO() != range[1]?.ToISO()) {
                this._updated = true;
            }
            this._startSBTime = range[0];
            this._endSBTime = range[1];
        }
    }

    PanelClosed(): void {
        if (!this._updated) {
            return;
        }

        if (!this._startSBTime && !this._endSBTime) {
            this.selectionChange.emit(null);
        } else {
            this.selectionChange.emit([this._startSBTime, this._endSBTime]);
        }
        this._updated = false;
    }

    TimeSelectClicked(): void {
        if (this.isMobile) {
            const bottomSheetRef = this._MatBottomSheet.open(ChipTimeRangePickerBottomSheetComponent, {
                data: {CurrentTimeRange: [this._startSBTime, this._endSBTime], Labels: this.labels},
                disableClose: true
            });

            bottomSheetRef.afterDismissed().subscribe((data: {CurrentTimeRange: (SBTime | null)[]}) => {
                if (data) {
                    this.TimeChanged(data.CurrentTimeRange);
                }
                this.PanelClosed();
            });
        }
    }

    ClosePanel(): void {
        this.chipButton.CloseMenu();
        this.PanelClosed();
    }

    get startTimeISO(): string | null {
        return this._startSBTime ? this._startSBTime.ToISO() : null;
    }

    get endTimeISO(): string | null {
        return this._endSBTime ? this._endSBTime.ToISO() : null;
    }

    get startSBTime(): SBTime | null {
        return this._startSBTime;
    }

    get endSBTime(): SBTime | null {
        return this._endSBTime;
    }
}
